import DomEffects from '../utils/DomEffects';
import type IAccountNavigationElements from './IAccountNavigationElements';

function init(elements: IAccountNavigationElements) {
  const {
    $btn, $menu, $menuContainer,
  } = elements.getAll();

  if (!$menu) {
    return;
  }

  let isExpanded = false;

  const toggle = (expand: boolean) => {
    if (isExpanded === expand) return;

    if (expand) {
      DomEffects.expand($menuContainer);
      $btn.setAttribute('aria-expanded', 'true');
    } else {
      DomEffects.collapse($menuContainer);
      $btn.setAttribute('aria-expanded', 'false');
    }

    isExpanded = expand;
  };

  $menu.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();

      toggle(false);

      $btn.focus();
    }
  });

  $btn.addEventListener('click', () => {
    toggle(!isExpanded);
  });

  document.addEventListener('click', (event) => {
    if (isExpanded) {
      const target = event.target as Node;

      if (!$menu.contains(target) && !$btn.contains(target)) {
        toggle(false);
      }
    }
  });
}

export default {
  init,
};
